export default __webpack_public_path__ + "static/media/flv10.7e6cfae7.jpeg";